module.exports = __webpack_public_path__ + "static/scale-model-of-discover-denton-welcome-center-in-denton-texas-e3d8003d549c8d37fddee4801b0e3876.png";